import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // React Quill stilleri
import '../Blog.css';

const AdminPostForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams(); // URL'den post ID'sini al

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [message, setMessage] = useState('');
  const isEditing = !!id;

  const getApiUrl = (endpoint) => {
    const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192');
    return isLocal ? `http://${window.location.hostname}:3001${endpoint}` : endpoint;
  };

  useEffect(() => {
    if (isEditing) {
      const fetchPost = async () => {
        // Gerçek bir uygulamada, tek bir postu ID ile çekmek daha verimlidir.
        // Şimdilik tümünü çekip içinden buluyoruz.
        const response = await fetch(getApiUrl('/api/blog'));
        const posts = await response.json();
        const postToEdit = posts.find(p => p.id === id);
        if (postToEdit) {
          setTitle(postToEdit.title);
          setContent(postToEdit.content);
        }
      };
      fetchPost();
    }
  }, [id, isEditing]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    const token = localStorage.getItem('token');
    if (!token) {
        navigate('/login');
        return;
    }

    try {
      const url = isEditing ? getApiUrl(`/api/blog/${id}`) : getApiUrl('/api/blog');
      const method = isEditing ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method: method,
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ title, content })
      });

      if (response.ok) {
        navigate('/admin/posts'); // Başarılı işlem sonrası listeye yönlendir
      } else {
        const data = await response.json();
        setMessage(data.error || 'Error');
      }
    } catch (error) {
      setMessage('Network Error');
    }
  };

  return (
    <div>
      <h2>{isEditing ? t('blog.edit') : t('blog.newPost')}</h2>
      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-group">
          <label>{t('blog.postTitle')}</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>{t('blog.postContent')}</label>
          <ReactQuill 
            theme="snow" 
            value={content} 
            onChange={setContent} 
            modules={{
              toolbar: [
                ['bold', 'italic', 'underline', 'strike'],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                ['clean']
              ],
            }}
          />
        </div>
        <div className="form-actions">
            <button type="submit" className="btn btn-primary">
                {isEditing ? t('blog.update') : t('blog.publish')}
            </button>
        </div>
        {message && <p className="admin-message">{message}</p>}
      </form>
    </div>
  );
};

export default AdminPostForm;